import React, {PureComponent} from "react";
import {Group, Rect} from "react-konva";
import {connect} from "react-redux";
import {ManifoldSpacer, ManifoldStructureType} from "../../lib/manifolds";
import {getScaledValue, getUnscaledValue} from "../../actions/calculations-actions";
import {
    removeManifold,
    setOppositeStructureCollisionDetected,
    setStructureCollisionDetected,
    showManifoldEntryDialog
} from "../../actions/manifold-entry-actions";
import ManifoldSelectors from "../../reducers/main-manifold-reducer";
import ManifoldStructures from "./manifold-structures";
import ManifoldPipes from "./manifold-pipes";
import ManifoldService from "../../lib/services/manifold-service";
import {
    activateByArray,
    cleanChambersByArrayIsolator,
    cleanChambersByManifoldMainRowArray,
    deactivateByArray,
    modifyChambersByArray,
    modifyChambersByArrayIsolator,
    modifyChambersByManifoldVoidArray,
    cleanChambersByManifoldVoidArray, showInsertaTeeWarning, setInsertaTeeWarningType
} from "../../actions/chamber-actions";
import IsolatorService from "../../lib/services/isolator_service";
import {changeMainManifoldProp, clearBuildGenerationFlag} from "../../actions/manifold-actions";
import {INLET_MANIFOLD_ID, OUTLET_MANIFOLD_ID} from "../../lib/types";
import {modalAlertActions} from "../../actions/modal-alert.actions";
import ChamberService from "../../lib/services/chambers-service";
import {ManifoldUtils} from "../../lib/manifolds/utils";
import CurrentSelectedChamberSelectors from "../../reducers/current-selected-chamber-reducer";
import {ManifoldEntryFormValueType} from "../ManifoldEntry";
import ProjectSelectors from "../../reducers/project-reducer";

class Manifold extends PureComponent {

    state = this.getInitialState();

    get height() {
        return (this.props.chamberHeight * this.props.manifold.assembly.length) +
            ((this.props.manifold.assembly.length - 1) * this.props.rowSpacing);
    }

    get width() {
        return this.trunkSeparationByManifold(this.props.manifold);
    }

    get x() {
        return this.props.x - this.width;
    }

    get y() {
        return this.props.y;
    }

    /**
     * TODO Remove
     * @returns {*}
     */
    get trunkSeparation() {
        debugger;
        console.error(`
        +++++++++++++++++++
        stop using trunkSeparation getter
        +++++++++++++++++++
        `);

    }

    /**
     * TODO Remove
     * @returns {*}
     */
    get structureSize() {
        debugger;
        console.error(`
        +++++++++++++++++++
        stop using structureSize getter
        +++++++++++++++++++
        `);

    }

    /**
     * Returns the trunk separation of the requested manifold
     * @param manifold
     * @returns {*}
     */
    trunkSeparationByManifold(manifold) {
        const trunkSep = manifold.getTrunkSeparation(
            this.props.chamberRows[manifold._letRow],
            this.props.chamberRows,
            this.props.manifoldSeparations,
            false,
            this.props.stoneBedSeparationDistance) || 0;
        return this.props.getScaledValue(trunkSep);
    }

    /**
     * Returns the structure Size separation of the requested manifold
     * @param manifold
     * @returns {*}
     */
    structureSizeByManifold(manifold) {
        try {
            let part = manifold
                    .assembly
                    .find(part => part.rowIndex === manifold._letRow),
                nyloplastStructureSize = manifold.manifoldSize.nyloplastStructureSize,
                concreteStructureSize = manifold.manifoldSize.concreteStructureSize;

            if (!nyloplastStructureSize) nyloplastStructureSize = 30;
            if (!concreteStructureSize) concreteStructureSize = 48;

            if (part.structureType === ManifoldStructureType.Nyloplast) {
                return this.props.getScaledValue(nyloplastStructureSize / 12);
            } else {
                return this.props.getScaledValue(concreteStructureSize / 12);
            }
        } catch (exception) {
            console.error(`Manifold.structureSize() : ${exception.message}`);
            return 0;
        }
    }

    getOverlappedManifoldHighlight() {
        return {
            showManifoldConflict: true,
            basingLineThickness: 0.5,
            structureRoundStrokeColor: "darkred",
            structureSquareStrokeColor: "darkred",
            structureNyloplastStrokeColor: "darkred",
            structureRoundFillColor: "orange",
            structureSquareFillColor: "orange",
            structureNyloplastFillColor: "orange",
            pipeLineStrokeWidth: 0.8,
            pipeLineColor: "red",
            reset: true,
            isOverlap: true,
            isMainManifold: false
        };
    }

    getCurrentManifoldHighlight() {
        return {
            showManifoldConflict: false,
            basingLineThickness: 0.1,
            structureRoundStrokeColor: "DarkRed",
            structureSquareStrokeColor: "DarkRed",
            structureNyloplastStrokeColor: "DarkRed",
            structureRoundFillColor: "Yellow",
            structureSquareFillColor: "Yellow",
            structureNyloplastFillColor: "Yellow",
            pipeLineStrokeWidth: 0.5,
            pipeLineColor: "#0078D4",
            reset: false,
            isOverlap: false,
            isMainManifold: true
        };
    }

    getInitialState() {
        return {
            showManifoldConflict: false,
            basingLineThickness: 0.1,
            structureRoundStrokeColor: "red",
            structureSquareStrokeColor: "red",
            structureNyloplastStrokeColor: "blue",
            structureRoundFillColor: "white",
            structureSquareFillColor: "white",
            structureNyloplastFillColor: "lightblue",
            pipeLineStrokeWidth: 0.5,
            pipeLineColor: "green",
            reset: false,
            isOverlap: false,
            isMainManifold: false,
            reload: false
        };
    }

    resetState() {
        this.setState({...this.getInitialState()});
    }

    showOverlapHighlight() {
        if (
            this.props.overlappingManifold
            && this.props.isOverlapPresent
        ) {
            this.setState(this.getOverlappedManifoldHighlight());
        } else if (
            this.state.reset
            && !this.props.isOverlapPresent
        ) {
            if (this.state.isMain) {
                this.setState(this.getCurrentManifoldHighlight());
            } else {
                if (!this.props.isOverlapPresent) {
                    this.resetState();
                }

            }
        }
    }

    showCurrentManifoldHighlight() {
        if (this.props.currentManifold && this.props.currentManifold._id === this.props.manifold._id) {
            if (!this.state.isOverlap) {
                this.setState(this.getCurrentManifoldHighlight());
            }
            this.showOverlapHighlight();
        } else {
            this.resetState();
        }
    }

    handleManifoldClick() {
        const manifoldChamber = this.props.chamberRows[this.props.manifold.letRow].chambers[this.props.manifold.letColumn];
        let accessory = manifoldChamber.upperCapAccessory && manifoldChamber.upperCapAccessory.manifoldId === this.props.manifold.id
            ? manifoldChamber.upperCapAccessory
            : manifoldChamber.lowerCapAccessory;
        this.props.showManifoldEntryDialog(this.props.manifold.id, accessory);
    }

    componentDidMount() {
        if (!this.props.loadingBed)
            IsolatorService.setIsolator(this.props.manifold, this.props.chamberbed, this.props);

        this.checkForCollisions();

        const {forceManifoldSpacer} = this.props.manifold._manifoldSize;

        if (
            this.props.manifold &&
            this.props.manifold._isManifoldInner === false &&
            this.props.manifold._userModified === false
        ) {
            let manifoldTypeId = (this.props.manifold._isInlet)
                ? "INLET_MANIFOLD_ID"
                : "OUTLET_MANIFOLD_ID";

            const manifoldConstruct = ManifoldUtils.getManifoldConstruct(
                this.props.chamberType.id,
                manifoldTypeId,
                this.props.totalStorageProvided,
                this.props.manifold._isManifoldInner
            );

            let numberOfRows = (this.props.manifold._spacer === ManifoldSpacer.gap)
                ? this.props.manifold._stubsNumber * 2
                : this.props.manifold._stubsNumber + 1;

            if (forceManifoldSpacer) {
                numberOfRows += 1;
            }

            const config = {
                removeTop: this.props.manifold._isUpper,
                removeRightToLeft: (ManifoldService.getDirection(this.props.manifold._letRow, this.props.chamberbed) === 1),
                numberOfRows: numberOfRows,
                numberOfChambers: manifoldConstruct.rules.placement["chambersPerRow"],
                oppositeSideChambers: 0,
                remove: true,
                chamberPosition: {
                    row: this.props.manifold._letRow,
                    col: this.props.manifold._letColumn
                }
            };

            if (!this.props.manifold._isManifoldInner &&
                manifoldTypeId === "OUTLET_MANIFOLD_ID" &&
                this.props.manifold._stubsNumber === 0 &&
                manifoldConstruct.structureType === "nyloplast"
            ) {
                config.numberOfRows = 1;
            }

            ChamberService.setChamberManifoldIdMeta(
                "isVoidArray",
                ManifoldService.buildManifoldVoidArray(config),
                this.props.manifold.letRow,
                this.props.manifold.letColumn,
                this.props
            );

            ChamberService.setChamberManifoldIdMeta(
                "isManifoldConnectedArray",
                ManifoldService.getCoordinatesForManifoldActiveRowForMetadata(config),
                this.props.manifold.letRow,
                this.props.manifold.letColumn,
                this.props
            );
        }
    }

    componentDidUpdate(prevProps) {

        // Affects stubs number on manifold resize - 1506235611. Moving handles crashes minicad
        if (this.props.chamberbed.numOfRows !== prevProps.chamberbed.numOfRows) {
            // Needs to run on the second loop of render.
            setTimeout(() => {
                let newStubCount = this.props.manifold._stubsNumber;
                const leftCount = this.props.chamberbed.numOfRows - this.props.manifold._letRow;
                const rightCount = this.props.manifold._letRow;
                const testLeftUpper = (this.props.manifold._direction === 2 && this.props.manifold._isUpper && newStubCount >= leftCount);
                const testRightUpper = (this.props.manifold._direction === 1 && this.props.manifold._isUpper && newStubCount > this.props.manifold._letRow);
                const testRightLower = (this.props.manifold._direction === 2 && !this.props.manifold._isUpper && newStubCount > leftCount);
                const testLeftLower = (this.props.manifold._direction === 1 && !this.props.manifold._isUpper && newStubCount >= rightCount);

                if ((testRightUpper || testLeftUpper) && this.props.manifold._isInlet) {
                    console.error("testRightUpper || testLeftUpper === TRUE, validation for inner manifolds");
                    if (this.props.manifold._direction === 2) newStubCount = newStubCount - (newStubCount - leftCount) - 1;
                    if (this.props.manifold._direction === 1) newStubCount = newStubCount - (newStubCount - this.props.manifold._letRow);
                }
                if ((testLeftLower || testRightLower) && this.props.manifold._isInlet) {
                    console.error("testLeftLower || testRightLower === TRUE, validation for inner manifolds");
                    if (this.props.manifold._direction === 2) newStubCount = newStubCount - (newStubCount - leftCount) - 1;
                    if (this.props.manifold._direction === 1) newStubCount = newStubCount - (newStubCount - rightCount);
                }

                this.props.changeMainManifoldProp(this.props.manifold._id, newStubCount, ManifoldEntryFormValueType.NUMBER_OF_STUBS);
            }, 0);
        }

        if (this.props.manifoldEntry !== prevProps.manifoldEntry) {
            this.showCurrentManifoldHighlight();
        }

        if (this.props._userModified !== prevProps._userModified) {
            this.setState((state, props) => ({reload: !state.reload}));
        }

        // checkForCollisions() triggers
        try {

            const capChamberInProp = (
                this.props.chamberRows[this.props.manifold._letRow] && this.props.chamberRows[this.props.manifold._letRow]._chambers
            )
                ? this.props.chamberRows[this.props.manifold._letRow]._chambers[this.props.manifold._letColumn] :
                null;
            const capChamberInPrevProps = (
                prevProps.chamberRows[this.props.manifold._letRow]._chambers && prevProps.chamberRows[this.props.manifold._letRow]._chambers
            )
                ? prevProps.chamberRows[this.props.manifold._letRow]._chambers[this.props.manifold._letColumn] :
                null;

            if (this.props.chamberType.id !== prevProps.chamberType.id) {
                this.checkForCollisions(true);
            }

            if (
                (
                    capChamberInProp &&
                    capChamberInPrevProps &&
                    capChamberInProp._upperCapAccessory &&
                    capChamberInPrevProps._upperCapAccessory &&
                    capChamberInProp._upperCapAccessory.variant !== capChamberInPrevProps._upperCapAccessory.variant
                ) || (
                    capChamberInProp &&
                    capChamberInPrevProps &&
                    capChamberInProp._lowerCapAccessory &&
                    capChamberInPrevProps._lowerCapAccessory &&
                    capChamberInProp._lowerCapAccessory.variant !== capChamberInPrevProps._lowerCapAccessory.variant
                )
            ) {
                this.checkForCollisions(true);
            }

            if (
                (
                    capChamberInProp &&
                    capChamberInPrevProps &&
                    capChamberInProp.manifoldSize &&
                    capChamberInProp.manifoldSize !== capChamberInPrevProps.manifoldSize
                )
            ) {
                this.checkForCollisions(true);
            }

            if (
                (
                    capChamberInProp &&
                    capChamberInPrevProps &&
                    capChamberInProp.manifoldDirection &&
                    capChamberInProp.manifoldDirection !== capChamberInPrevProps.manifoldDirection
                )
            ) {
                this.checkForCollisions(true);
            }


        } catch (e) {
            if (e.message !== "Cannot read properties of undefined (reading '_chambers')")
                console.info("checkForCollisions() triggers " + e.message);
        }
        // checkForCollisions() triggers  -EOB

    }

    /**
     * Check for COLLISIONS BETWEEN MANIFOLD AND CHAMBERS AND OR STRUCTURES collisions on void and other structures
     * @param wasUpdated {boolean} - set to true only on componentDidUpdate
     * @returns {null}
     */
    checkForCollisions(wasUpdated = false) {

        try {

            const debugCollisions = false;

            const {isManifoldInner, manifoldSize, isUpper} = this.props.manifold;
            const {trunk, size, ChamberTypeId} = manifoldSize;
            const chamber = CurrentSelectedChamberSelectors.getChamberByPosition(this.props.manifold._letRow, this.props.manifold._letColumn);
            const {variant: structureType} = (chamber._upperCapAccessory && chamber._upperCapAccessory.manifoldId === this.props.manifold._id) ? chamber._upperCapAccessory : chamber._lowerCapAccessory;

            const trunkSize = size.toLowerCase().split("x")[0];

            let FIX_HORIZONTAL_VALUE;
            if (structureType === "nyloplast") {
                FIX_HORIZONTAL_VALUE = 1;
            } else {
                FIX_HORIZONTAL_VALUE = 0;
            }

            let FIX_VERTICAL_VALUE;
            if (structureType !== "nyloplast" &&
                ChamberTypeId === "MC-4500") {
                FIX_VERTICAL_VALUE = 2.5;
            } else {
                FIX_VERTICAL_VALUE = 0;
            } // TODO fix value not responding PP. For 1224455567 "Internal manifold allows for overlapping structures"

            // size === '18x18'
            let FIX_VERTICAL_NON_STRUCTURE_VALUE;
            if (structureType !== "nyloplast" &&
                ChamberTypeId === "MC-4500" &&
                trunkSize === "30"
            ) {
                FIX_VERTICAL_NON_STRUCTURE_VALUE = 2.5;
            } else {
                FIX_VERTICAL_NON_STRUCTURE_VALUE = 0;
            } // TODO fix value not responding PP. For 1224455567 "Internal manifold allows for overlapping structures"

            if (isManifoldInner) {
                let verticalChambersToRemoveArray = [];
                let horizontalChambersToRemoveArray = [];

                const PERIMETER = 12;
                const rowIndex = this.props.manifold.assembly.find(asm => asm.structureType !== null).rowIndex;
                let rootCol = this.props.manifold.letColumn;
                let col = this.props.manifold.letColumn;
                const rootRow = this.props.manifold.letRow;
                const chamberRow = this.props.chamberRows[rowIndex];
                const increment = this.props.manifold.isUpper ? -1 : 1; //add subtract based on upper or lower

                const mainChamber = this.props.chamberRows[rootRow].chambers[rootCol];

                const chamberInstalledLength = this.props.chamberType.installedLength * 12;
                const chamberWithInches = this.props.getUnscaledValue(mainChamber.width) * 12;
                const offSetForTrunkSep = chamberWithInches - chamberInstalledLength;

                let trunkSeparationInches = this.props.getUnscaledValue(this.trunkSeparationByManifold(this.props.manifold)) * 12;
                const halfTrunkSizeInches = (trunk * 12) / 2;
                const halfStructureSizeInches = (this.props.getUnscaledValue(this.structureSizeByManifold(this.props.manifold)) * 12) / 2;

                const isUpper = this.props.manifold.isUpper;
                let isLefty = (this.props.manifold.direction === 1);
                if (!isUpper) isLefty = (this.props.manifold.direction === 2);
                let incrementSides = isLefty ? -1 : 1;
                if (!isUpper) incrementSides *= -1;

                const endCapsWidth = this.props.getUnscaledValue(chamberRow._endCapWidth) * 12;
                const numberOfCaps = 1;
                let capsWidths = endCapsWidth * numberOfCaps;

                // 2. Work on VERTICAL  collision
                let chambersToCross = 0;
                col += increment;
                let nextChamber = chamberRow.chambers[col];
                let colToRemove = 0;
                let verticalCounterForStepFour = 0;
                // run over chambers void for vertical test
                while (!nextChamber.active) {
                    chambersToCross += 1;
                    col += increment;
                    trunkSeparationInches = trunkSeparationInches - offSetForTrunkSep;
                    verticalCounterForStepFour++;
                    nextChamber = chamberRow.chambers[col];
                    colToRemove = col;
                }

                // setup and used on  step 4
                const oppositeChamber = {...nextChamber};
                const totalVoidWidth = chamberWithInches * chambersToCross;
                const totalVerticalVoidNoCapsSize = totalVoidWidth - capsWidths;

                let verticalFullStructureSize = 0;
                verticalFullStructureSize = trunkSeparationInches + halfTrunkSizeInches + halfStructureSizeInches + FIX_VERTICAL_NON_STRUCTURE_VALUE + PERIMETER;
                const hasVerticalCollision = (totalVerticalVoidNoCapsSize <= verticalFullStructureSize);
                // 2. -EOB


                // 3. Work on HORIZONTAL collision
                const chamberHeightInches = this.props.getUnscaledValue(mainChamber.height) * 12;
                const halfChamberHeightInches = chamberHeightInches / 2;
                let horizontalFullStructureSize = 0;
                horizontalFullStructureSize = halfChamberHeightInches + halfStructureSizeInches + PERIMETER - FIX_HORIZONTAL_VALUE;
                let testVoidLengthOppositeSize = chamberHeightInches;
                let chamberToTest = {...mainChamber};
                let remainingRows = 0;
                let horizontalChambersToRemove = 0;
                remainingRows = (isLefty) ? this.props.chamberBedNumOfRows - (rootRow + 1) : this.props.chamberBedNumOfRows + (rootRow + 1);
                let rowCounted = rootRow + incrementSides;
                try {
                    chamberToTest = this.props.chamberRows[rootRow - incrementSides].chambers[rootCol + increment];
                    let vChambersToCross = rootRow + incrementSides;
                    if (!chamberToTest.active) // test if inactive
                        testVoidLengthOppositeSize += chamberHeightInches;
                    let testSizeForRemoval = testVoidLengthOppositeSize;
                    while (remainingRows >= 1) {
                        rowCounted -= incrementSides;
                        chamberToTest = this.props.chamberRows[rowCounted - incrementSides].chambers[rootCol + increment];
                        if (chamberToTest.active) {
                            if (testSizeForRemoval < horizontalFullStructureSize) {
                                testSizeForRemoval += chamberHeightInches;
                                horizontalChambersToRemove += 1;
                            }
                        }
                        remainingRows -= 1;
                        vChambersToCross -= 1;
                    }
                } catch (e) {
                    // Brakes on non existing chambers and fixes remaining rows to 0
                    remainingRows = 0;
                }

                // 3. -EOB
                const hasHorizontalCollision = (testVoidLengthOppositeSize < horizontalFullStructureSize);

                // 4.  Work on STRUCTURES collision
                let hasHorizontalStructuresCollision = false;
                let oppositeManifold = null;
                let oppositeVerticalFullStructureSize = 0;
                let hzVoidMinusFullStructure = 0;
                let OPPOSITE_FIX_HORIZONTAL_VALUE = 0;
                let oppositeAccessory = "";
                let oppositeStructureType = "";
                let manifoldsColliding = [];
                if (oppositeChamber) {
                    if (oppositeChamber._upperCapAccessory !== null || oppositeChamber._lowerCapAccessory !== null) {


                        oppositeAccessory = (oppositeChamber._upperCapAccessory !== null) ? oppositeChamber._upperCapAccessory : oppositeChamber._lowerCapAccessory;
                        oppositeStructureType = oppositeAccessory.variant;
                        oppositeManifold = ManifoldSelectors.getManifoldByIdFromMain(oppositeAccessory.manifoldId);

                        OPPOSITE_FIX_HORIZONTAL_VALUE = (
                            oppositeStructureType !== "nyloplast" &&
                            ChamberTypeId === "MC-4500" // &&
                        ) ? 2.5 : 0;

                        let oppositeTrunkSeparationInches = this.props.getUnscaledValue(this.trunkSeparationByManifold(oppositeManifold)) * 12;
                        oppositeTrunkSeparationInches = oppositeTrunkSeparationInches - (offSetForTrunkSep * verticalCounterForStepFour);
                        const oppositeHalfTrunkSizeInches = (oppositeManifold.manifoldSize.trunk * 12) / 2;
                        const oppositeHalfStructureSizeInches = (this.props.getUnscaledValue(this.structureSizeByManifold(oppositeManifold)) * 12) / 2;
                        oppositeVerticalFullStructureSize = oppositeTrunkSeparationInches + oppositeHalfTrunkSizeInches + oppositeHalfStructureSizeInches + PERIMETER + OPPOSITE_FIX_HORIZONTAL_VALUE;
                        hzVoidMinusFullStructure = (totalVerticalVoidNoCapsSize - verticalFullStructureSize) + FIX_VERTICAL_VALUE;
                        hasHorizontalStructuresCollision = oppositeVerticalFullStructureSize > hzVoidMinusFullStructure;

                        if (
                            hasHorizontalStructuresCollision
                        ) {
                            manifoldsColliding.push(oppositeManifold._id);
                            manifoldsColliding.push(this.props.manifold._id);
                        }

                    }
                }
                // 4. -EOB

                // DONT REMOVE, it helps with debugging
                if (debugCollisions)
                    console.table({
                        wasUpdated,
                        where: " === checkForCollisions() === ",
                        structureType,
                        oppositeStructureType,
                        id: this.props.manifold._id,
                        manifoldSize_size: size,
                        ChamberTypeId,
                        trunk,
                        structureSizeByManifold: this.props.getUnscaledValue(this.structureSizeByManifold(this.props.manifold)),
                        FIX_HORIZONTAL_VALUE,
                        FIX_VERTICAL_VALUE,
                        FIX_VERTICAL_NON_STRUCTURE_VALUE,
                        OPPOSITE_FIX_HORIZONTAL_VALUE,
                        test0: "-VerticalCollision-----------",
                        totalVerticalVoidNoCapsSize,
                        verticalFullStructureSize,
                        verticalTot: totalVerticalVoidNoCapsSize - verticalFullStructureSize,
                        hasVerticalCollision
                        /*test1: "-hasHorizontalCollision------",
                        testVoidLengthOppositeSize,
                        horizontalFullStructureSize,
                        horizontalTot: testVoidLengthOppositeSize - horizontalFullStructureSize,
                        hasHorizontalCollision,
                        sp2: "-hasHorizontalStructuresCollision-",
                        oppositeVerticalFullStructureSize,
                        hzVoidMinusFullStructure,
                        col3: oppositeVerticalFullStructureSize - hzVoidMinusFullStructure,
                        hasHorizontalStructuresCollision,
                        manifoldsColliding,*/
                    });

                // 5. Run testing RULES
                if (hasHorizontalStructuresCollision) {
                    if (wasUpdated) {
                        // manifoldsColliding
                        this.props.setOppositeStructureCollisionDetected(true, manifoldsColliding);
                        this.props.modalAlertActions({
                            toggle: true,
                            text: this.props.content[this.props.lang]["structuresCollidedOnUpdate"]
                        });
                        console.info("structures collision detected on update");
                        return null;
                    } else {
                        this.props.removeManifold(this.props.manifold);
                        this.props.cleanChambersByArrayIsolator(
                            this.props.manifold._id,
                            this.props.manifold._letRow,
                            this.props.manifold._letColumn
                        );
                        this.props.modalAlertActions({
                            toggle: true,
                            text: this.props.content[this.props.lang]["structuresCollided"]
                        });
                        console.info("structures collision detected");
                        return null;
                    }
                } else {
                    this.props.setOppositeStructureCollisionDetected(false, []);
                }

                if (hasVerticalCollision) {
                    // build deletable arrays
                    let chamberToTestHorizontalVoid = this.props.chamberRows[rootRow].chambers[rootCol + increment];
                    let colCounter = rootCol + increment;
                    let rowCounter = rootRow;
                    while (!chamberToTestHorizontalVoid._active) {
                        colCounter += increment;
                        rowCounter += incrementSides;
                        horizontalChambersToRemoveArray.push({ //
                            row: chamberToTestHorizontalVoid._row,
                            col: (isUpper) ? rootCol - chambersToCross - 1 : rootCol + chambersToCross + 1
                        });
                        chamberToTestHorizontalVoid = this.props.chamberRows[rowCounter].chambers[rootCol + increment];
                    }
                    // -EOB
                } else {
                    this.props.setStructureCollisionDetected(false);
                }

                if (hasHorizontalCollision) {
                    // Array for horizontal removal
                    let chamberToTestVerticalVoid = this.props.chamberRows[rootRow].chambers[rootCol + increment];
                    let colCount = rootCol + increment;
                    while (!chamberToTestVerticalVoid._active) {
                        verticalChambersToRemoveArray.push({ //
                            row: chamberToTestVerticalVoid._row - incrementSides,
                            col: chamberToTestVerticalVoid._col
                        });
                        colCount += increment;
                        chamberToTestVerticalVoid = this.props.chamberRows[rootRow].chambers[colCount];
                    }
                    // -EOB
                    this.props.setStructureCollisionDetected(true);
                } else {
                    this.props.setStructureCollisionDetected(false);
                }

                if (hasHorizontalCollision || hasVerticalCollision) {

                    // Test if the chamber to be removed is used by a manifold
                    for (let i = 0; i < verticalChambersToRemoveArray.length; i++) {
                        const chm = verticalChambersToRemoveArray[i];
                        if (CurrentSelectedChamberSelectors.isManifoldAttachedToChamber(chm.row, chm.col)) {

                            this.props.removeManifold(this.props.manifold);
                            this.props.cleanChambersByArrayIsolator(
                                this.props.manifold._id,
                                this.props.manifold._letRow,
                                this.props.manifold._letColumn
                            );

                            ManifoldService.generateChamberVoid(
                                [...verticalChambersToRemoveArray],
                                false,
                                this.props);
                            //
                            this.props.modalAlertActions({
                                toggle: true,
                                text: this.props.content[this.props.lang]["structuresCollided"]
                            });
                            this.props.setStructureCollisionDetected(true);
                            return;
                        }
                    }


                    for (let i = 0; i < horizontalChambersToRemoveArray.length; i++) {
                        const chm = horizontalChambersToRemoveArray[i];
                        if (CurrentSelectedChamberSelectors.isManifoldAttachedToChamber(chm.row, chm.col)) {
                            this.props.removeManifold(this.props.manifold);
                            this.props.cleanChambersByArrayIsolator(
                                this.props.manifold._id,
                                this.props.manifold._letRow,
                                this.props.manifold._letColumn
                            );

                            ManifoldService.generateChamberVoid(
                                [...horizontalChambersToRemoveArray],
                                false,
                                this.props);

                            this.props.modalAlertActions({
                                toggle: true,
                                text: this.props.content[this.props.lang]["structuresCollided"]
                            });
                            return;
                        }
                    }

                    const mainVoidArray = [...verticalChambersToRemoveArray, ...horizontalChambersToRemoveArray];

                    ManifoldService.generateChamberVoid(
                        mainVoidArray,
                        true,
                        this.props);

                    ChamberService.setChamberManifoldIdMeta(
                        "isVoidArray",
                        mainVoidArray,
                        this.props.manifold.letRow,
                        this.props.manifold.letColumn,
                        this.props
                    );

                    if (hasHorizontalCollision)
                        console.info("%c hasHorizontalCollision ", "background: yellow; color: red");
                    if (hasVerticalCollision)
                        console.info("%c hasVerticalCollision ", "background: yellow; color: red");
                }
                // 5. -EOB
            } else {
                if (debugCollisions) console.info("Its an outer manifold, wont do collision test for separation");
            }
        } catch (error) {
            console.error(`Manifold.checkForCollisions() :: ${error.message}`);
        }
    }

    render() {
        try {
            return (
                <Group
                    x={this.x}
                    y={this.y}
                    width={this.width}
                    height={this.height}
                    // onClick={this.handleManifoldClick.bind(this)}>    << CULTEC MOD
                >
                    <Rect fill={"lightpink"} width={this.width} height={this.height}
                          visible={this.props.enableDebugging}/>
                    <Rect fill={"rgb(255 255 0 / 65%)"} width={this.width} height={this.height}
                          visible={this.state.showManifoldConflict}/>
                    <Rect fill={"rgba(160, 238, 234, 0.36)"} width={this.width} height={this.height}
                          visible={this.state.isMainManifold}/>
                    <ManifoldPipes {...this.props} />
                    <ManifoldStructures {...this.props} />
                </Group>
            );
        } catch (exception) {
            return null;
        }
    }
}

let mapStateToProps = state => {
    return {
        enableDebugging: state.globals.enableDebuging,
        isSystemGenerated: state.globals.isSystemGenerated,
        chamberRows: state.chamberbed.chamberRows,
        chamberRowSpacing: state.chamberbed.chamberRowSpacing,
        chamberbed: state.chamberbed,
        chamberType: state.globals.chamberType,
        chamberEndCapType: state.globals.chamberEndCapType,
        structureDistance: state.calculations.structureDistance,
        manifoldSize: state.calculations.manifoldSize,
        structureSize: state.calculations.structureSize,
        manifoldStructures: state.stonebed.manifoldStructures,
        stoneBedSeparationDistance: state.stonebed.sepDistance,
        manifoldSeparations: state.calculations.manifoldSeparations,
        checkForOverlap: state.manifoldEntry.checkForOverlap,
        overlappedManifold: state.manifoldEntry.overlappedManifold,
        overlappingManifold: state.manifoldEntry.overlappingManifold,
        currentManifold: state.manifoldEntry.currentManifold,
        structureCollisionDetected: state.manifoldEntry.structureCollisionDetected,
        oppositeStructureCollisionDetected: state.manifoldEntry.oppositeStructureCollisionDetected,
        oppositeManifoldsIds: state.manifoldEntry.oppositeManifoldsIds,
        totalStorageProvided: state.calculations.totalStorageProvided,
        chamberBedNumOfRows: state.chamberbed.numOfRows,


        upperManifolds: ManifoldSelectors.getFullManifoldsByType("upper"),
        lowerManifolds: ManifoldSelectors.getFullManifoldsByType("lower"),

        upperManifoldsArray: ManifoldSelectors.getManifoldsByType("upper"),
        lowerManifoldsArray: ManifoldSelectors.getManifoldsByType("lower"),

        entryManifoldId: state.manifoldEntry.manifoldId,
        isOverlapPresent: state.manifoldEntry.overlapPresent,
        manifoldEntry: state.manifoldEntry,

        lang: state.localization.lang,
        content: state.localization.content,

        loadingBed: state.multiBed.loadingBed,
        isMultiBedProject: ProjectSelectors.isMultiBedProject()
    };
};

const mapDispatchToProps = {
    getUnscaledValue,
    getScaledValue,
    showManifoldEntryDialog,
    modifyChambersByArray,
    deactivateByArray,
    activateByArray,
    modifyChambersByArrayIsolator,
    setStructureCollisionDetected,
    setOppositeStructureCollisionDetected,
    clearBuildGenerationFlag,
    removeManifold,
    cleanChambersByArrayIsolator,
    modalAlertActions,
    modifyChambersByManifoldVoidArray,
    cleanChambersByManifoldMainRowArray,
    changeMainManifoldProp,
    cleanChambersByManifoldVoidArray,
    showInsertaTeeWarning,
    setInsertaTeeWarningType
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Manifold);



// WEBPACK FOOTER //
// ./src/components/Drawings/manifold.js